import EFPic from '@/components/UI/EFPic';
import { EFModalOpenSvgH5 } from '@/components/UI/svg/mm100';
import { useGlobal } from '@/utils/useGlobal';
// import { TweenMax } from 'gsap';
import { useEffect } from 'react';
import css from './index.module.scss';

export default function D() {
    const { useLang, useState, Link } = useGlobal();
    const { t } = useLang('csr');
    const [data, setData] = useState([
        {
            img: ['/img/csr/h5/4_1.webp', '/img/csr/h5/4_1.png'],
            pName: t('secD_list1_pName'),
            pDesc: t('secD_list1_pDesc'),
            pLink: '/delta-pro-portable-power-station',
            pLinkText: t('secD_list_link'),
            pTimeDesc: t('secD_list1_pTimeDesc'),
            flag: false,
        },
        {
            img: ['/img/csr/h5/4_2.webp', '/img/csr/h5/4_2.png'],
            pName: t('secD_list2_pName'),
            pDesc: t('secD_list2_pDesc'),
            pLink: '/delta-max-portable-power-station',
            pTimeDesc: t('secD_list2_pTimeDesc'),
            flag: false,
        },
        {
            img: ['/img/csr/h5/4_3.webp', '/img/csr/h5/4_3.png'],
            pName: t('secD_list3_pName'),
            pDesc: t('secD_list3_pDesc'),
            pLink: '/delta-2-portable-power-station',
            pTimeDesc: t('secD_list3_pTimeDesc'),
            flag: false,
        },
        {
            img: ['/img/csr/h5/4_4.webp', '/img/csr/h5/4_4.png'],
            pName: t('secD_list4_pName'),
            pDesc: t('secD_list4_pDesc'),
            pLink: '/400w-solar-panel',
        },
        {
            img: ['/img/csr/h5/4_5.webp', '/img/csr/h5/4_5.png'],
            pName: t('secD_list5_pName'),
            pDesc: t('secD_list5_pDesc'),
            pLink: '/220w-solar-panel',
        },
    ]);

    const [active, setActive] = useState(0)
    // 触屏拖拽mobile
    let startX = 0, flag = false;
    const touchStart = (e: any) => {
        startX = e.targetTouches[0].clientX;
        flag = true;
    };
    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0].clientX;
        if(flag){
            if(moveX < startX && active < data?.length - 1){
                e.currentTarget.style.left = -(1 + active) * 3 + (active === data?.length - 2 ? 0.35 : 0) + 'rem'; // 3 => 2.8width + 0.2gap， 最后一个单独计算
                setActive(active + 1);
                flag = false;
            }
            if(moveX > startX && active > 0){
                e.currentTarget.style.left = -(active - 1) * 3 + (active === data?.length - 1 ? 0.35 : 0) + 'rem';
                setActive(active - 1);
                flag = false;
            }
        }
    };

    const [change, setChange] = useState({statu: 0, key: 0})
    const toggleShow = (list: any, k: number) => {
        if(!list?.flag){
            const targetEl = document.querySelector(`.csr_h5_D .swiperLists .listDefault_${k}`) as HTMLElement;
            targetEl.animate(
                [
                    { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    { transform: `translate3d(0, -50px, 0)`, opacity: 0 },
                ],
                {
                    duration: 500,
                    delay: 0,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                    iterations: 1,
                },
            );
            setTimeout(()=>{
                setData([...data?.slice(0, k), { ...list, flag: !list?.flag }, ...data?.slice(k + 1)]);
                setChange({statu: !list?.flag ? 1 : -1, key: k });
            }, 500) 
        }
        if(list?.flag){
            const targetEl = document.querySelector(`.csr_h5_D .swiperLists .listToggle_${k}`) as HTMLElement;
            targetEl.animate(
                [
                    { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    { transform: `translate3d(0, 50px, 0)`, opacity: 0 },
                ],
                {
                    duration: 500,
                    delay: 0,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                    iterations: 1,
                },
            );
            const targetEl1 = document.querySelector(`.csr_h5_D .swiperLists .listToggle_${k} .pTimeDesc`) as HTMLElement;
            targetEl1.animate(
                [
                    { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    { transform: `translate3d(0, 20px, 0)`, opacity: 0 },
                ],
                {
                    duration: 500,
                    delay: 0,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                    iterations: 1,
                },
            );
            setTimeout(()=>{
                setData([...data?.slice(0, k), { ...list, flag: !list?.flag }, ...data?.slice(k + 1)]);
                setChange({statu: !list?.flag ? 1 : -1, key: k});
            }, 500) 
        }
    };

    useEffect(()=>{
        if(change.statu !== 0){
            if(change.statu === 1){
                const targetEl = document.querySelector(`.csr_h5_D .swiperLists .listToggle_${change.key}`) as HTMLElement;
                targetEl.animate(
                    [
                        { transform: `translate3d(0, 50px, 0)`, opacity: 0 },
                        { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    ],
                    {
                        duration: 500,
                        delay: 0,
                        fill: 'forwards',
                        easing: 'ease-in-out',
                        iterations: 1,
                    },
                );
                const targetEl1 = document.querySelector(`.csr_h5_D .swiperLists .listToggle_${change.key} .pTimeDesc`) as HTMLElement;
                targetEl1.animate(
                    [
                        { transform: `translate3d(0, 20px, 0)`, opacity: 0 },
                        { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    ],
                    {
                        duration: 500,
                        delay: 0,
                        fill: 'forwards',
                        easing: 'ease-in-out',
                        iterations: 1,
                    },
                );
            }
            if(change.statu === -1){
                const targetEl = document.querySelector(`.csr_h5_D .swiperLists .listDefault_${change.key}`) as HTMLElement;
                targetEl.animate(
                    [
                        { transform: `translate3d(0, -50px, 0)`, opacity: 0 },
                        { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    ],
                    {
                        duration: 500,
                        delay: 0,
                        fill: 'forwards',
                        easing: 'ease-in-out',
                        iterations: 1,
                    },
                );
            }
        }
    }, [change])

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // title文字动画
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_D',
            triggerHook: 1,
            offset: 230,
        })
            .setClassToggle('.csr_h5_D .innerBox', 'enter')  // 方式1（css)
            // .setTween(TweenMax.staggerTo('.csr_h5_D .title .letter_d', 0.5, { opacity: 1, top: 0, stagger: 0.1 }, 0.0333)) // 方式2(TweenMax)
            .addTo(controller);

        // swiper内容动效
        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_D .swiper_d',
        //     triggerHook: 1,
        //     offset: 400,
        // })
        //     .setClassToggle('.csr_h5_D .swiper_d', 'enter')
        //     .addTo(controller);
    }, []);

    const letters: [string] = t('secD_title').split('');

    return (
        <div className={`csr_h5_D ${css.csr_h5_D}`}>
            <div className="innerBox">
                <div className="titleBox">
                    <div className="title">
                        {letters?.map((letter: any, k: number) => (
                            <span key={k} className={`letter_d letter_${k}`}>
                                {letter}
                            </span>
                        ))}
                    </div>
                </div>
                <div className="swiper_d">
                    <ul className="swiperLists" onTouchMove={touchMove} onTouchStart={touchStart}>
                        {data?.map((list: any, k: number) => (
                            <li className="swiperList" key={k}>
                                <div className="listInner">
                                    {!list?.flag && (
                                        <div className={`listDefault listDefault_${k}`}>
                                            <div className="imgBox">
                                                <div className="img">
                                                    <EFPic src={list?.img} alt={list?.desc} aria-label={list?.desc} />
                                                </div>
                                            </div>
                                            <p className="pName">{list?.pName}</p>
                                            <p className="pDesc">{list?.pDesc}</p>
                                            <Link href={list?.pLink} className="pLink">
                                                {t('secD_list_link')}
                                            </Link>
                                        </div>
                                    )}
                                    {list?.flag && (
                                        <div className={`listToggle listToggle_${k}`}>
                                            <p className="pTime">{t('secD_list_pTime')}</p>
                                            <p className="pTimeDesc">{list?.pTimeDesc}</p>
                                        </div>
                                    )}

                                    {list?.pTimeDesc && (
                                        <div className={`svgIcon ${list?.flag ? 'open' : 'close'}`} onClick={() => toggleShow(list, k)}>
                                            <EFModalOpenSvgH5 />
                                        </div>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <p className="note">{t('secD_note')}</p>
            </div>
        </div>
    );
}
